module.exports = __webpack_public_path__ + "static/media/SDFSA_4-240w.2953ce5e.webp";